// extracted by mini-css-extract-plugin
export default {"logout":"LogoutBtn_logout__+RWKp"};